// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import Analyse from '../../Model/Analyse'

type Props = {
  analysis: Analyse,
  onClick: (analyse: Analyse) => void,
};

@observer
export default class AnalyseTableRow extends React.Component<Props, void> {
  
  handleClick = () => {
    this.props.onClick(this.props.analysis);
  }
  
  render() {
    const { analysis } = this.props;
    
    return (
      <tr className="analysis-row" onClick={this.handleClick}>
        <td>
          <Link to={`/analysis/${analysis.id}`}>{analysis.name}</Link>
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/Views/Analysis/AnalyseTableRow.js